exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".buttons--col--27p9ZwWx {\r\n  padding: 10px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/addEditNavBtns/buttons.css"],"names":[],"mappings":"AAAA;EACE,cAAc;CACf","file":"buttons.css","sourcesContent":[".col {\r\n  padding: 10px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"col": "buttons--col--27p9ZwWx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/addEditNavBtns/buttons.css
// module id = 403
// module chunks = 0